import React, { useState } from 'react';
import { CLIENT_LABEL_MAPPING } from '../utils/clientLabels';
import './ClientSelectorModal.css';

const ClientSelectorModal = ({ onClose, onSelect }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchBy, setSearchBy] = useState({
        Nome: true,
        ID: false,
        EnderecoCobranca: false
    });

    const fetchClients = async () => {
        if (!searchTerm.trim()) return;
        setLoading(true);
        try {
            const activeFields = Object.keys(searchBy).filter(k => searchBy[k]);
            const query = activeFields.map(field => `fields=${field}`).join('&');
            const res = await fetch(`/api/clientes?search=${encodeURIComponent(searchTerm)}&${query}`);
            if (res.ok) {
                const data = await res.json();
                setClients(data);
            }
        } catch (error) {
            console.error('Erro ao buscar clientes:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content client-selector-modal">
                <div className="win-title">
                    Selecionar Cliente
                    <button className="btn-close" onClick={onClose}>×</button>
                </div>
                <div className="win-body">
                    <div className="search-box">
                        <div className="criteria-row">
                            <label><input type="radio" name="modalSearchCriteria" checked={searchBy.Nome} onChange={() => setSearchBy({ Nome: true, ID: false, EndecoCobranca: false })} /> {CLIENT_LABEL_MAPPING['SobrenomeContato']}</label>
                            <label><input type="radio" name="modalSearchCriteria" checked={searchBy.ID} onChange={() => setSearchBy({ Nome: false, ID: true, EndereçoDeCobrança: false })} /> Código</label>
                            <label><input type="radio" name="modalSearchCriteria" checked={searchBy.EnderecoCobranca} onChange={() => setSearchBy({ Nome: false, ID: false, EnderecoCobranca: true })} /> {CLIENT_LABEL_MAPPING['EnderecoCobranca']}</label>
                        </div>
                        <div className="input-group">
                            <input
                                type="text"
                                placeholder="Buscar cliente..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && fetchClients()}
                                autoFocus
                            />
                            <button className="btn-classic" onClick={fetchClients}>Buscar</button>
                        </div>
                    </div>

                    <div className="selector-list">
                        {loading ? <p style={{ padding: '10px' }}>Buscando...</p> :
                            clients.length === 0 ? (
                                <p style={{ padding: '10px' }}>
                                    {searchTerm ? 'Nenhum cliente encontrado.' : 'Digite um termo para pesquisar.'}
                                </p>
                            ) : (
                                clients.map(c => (
                                    <div key={c.ID} className="selector-item" onClick={() => onSelect(c)}>
                                        <div className="client-main-info">
                                            <strong>{c.SobrenomeContato}, {c.PrimeiroNomeContato}</strong>
                                            <span>#{c.ID}</span>
                                        </div>
                                        <div className="client-sub-info">
                                            <span>{c.Cidade} - {c.EstadoProvincia}</span>
                                            <span>{c.Telefone}</span>
                                        </div>
                                    </div>
                                ))
                            )
                        }
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="btn-classic danger" onClick={onClose}>Cancelar</button>
                </div>
            </div>
        </div>
    );
};

export default ClientSelectorModal;
